import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment/moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { submitDnataExtraForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const TimeRegulationForm = ({
  appData: { dnataOnboarding, firstName, lastName },
  submitForm,
}) => {
  const typeCode = "YDN0";
  const fullName = `${firstName} ${lastName}`;
  const submitted = dnataOnboarding && dnataOnboarding[typeCode];

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p>
            The Working Time Regulations determine the maximum weekly working
            time, patterns of work and holidays, plus the daily and weekly rest
            periods for workers. They also cover the health and working hours of
            night workers.
          </p>
          <p>In Working Time Regulations provide the following rights:</p>
          <ul>
            <li>
              a limit of an average 48 hours a week on the hours a worker can be
              required to work, though individuals may choose to work longer by
              &apos;opting out&apos;
            </li>
            <li>11 consecutive hours rest in any 24-hour period</li>
            <li>one day off each week or 2 consecutive days every 2 weeks</li>
          </ul>
          <p>
            With regards to rest breaks it is the responsibility of Alpha LSG to
            ensure that you have the opportunity to take appropriate rest
            breaks, however it is your responsibility to ensure that these
            breaks are taken.
          </p>
          <p>
            With regards to the maximum weekly working hours, as noted above you
            can “opt out” of this element of the regulations and work in excess
            of these hours (but still ensuring that the rest breaks are adhered
            to).
          </p>
          <p>
            It is important that we are clear as to who has and has not opted
            out of the 48 hour element of the regulations and that our records
            are full up to date on this matter.
          </p>
          <p>
            To that end you are required to confirm your position on the 48
            working hours per week by completing the below and returning it to
            the HR department.
          </p>
        </div>
      ),
    },
    name: {
      key: "name",
      title: "Name of Employee",
      value: getVal("name"),
      disabled: true,
    },
    jobTitle: {
      key: "jobTitle",
      title: "Job Title",
      value: getVal("jobTitle"),
      mandatory: true,
    },
    decision: {
      title: "",
      value: getVal("decision"),
      type: "radio",
      radioOptions: [
        "I agree that I may work for more than the average 48 hours per week, and I am 'opting out'.",
        "I agree I will keep my working hours to a maximum of 48 hours per week, and I am not 'opting out'.",
      ],
      mandatory: true,
    },
    blurb2: {
      htmlObj: (
        <p className="font-weight-bold">
          NB: Young workers normally cannot opt-out of the 48 hour working week,
          as they may not normally work more than a 40 hours per week.
        </p>
      ),
    },

    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/dnata-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitForm(typeCode, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Working Time Regulations"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"dnata"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

TimeRegulationForm.propTypes = {
  appData: any,
  submitForm: func,
};

const mapDispatchToProps = {
  submitForm: submitDnataExtraForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(TimeRegulationForm);
